import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginResult } from '../models/login-result.model';
import { ForgotPasswordResponse } from '../models/forgot-password-response.model';
import { ChangePasswordResponse } from '../models/change-password-response.model';
import { GetRefreshTokenResponse } from '@/core/models/get-refreshToken-response.model';

@Injectable({
    providedIn: 'root'
})
export class AuthApi {
    http = inject(HttpClient);
    private baseUrl = `${environment.apiUrl}/auth`;
    header = { 'Content-Type': 'application/json' };

    login(email: string, password: string) {
        return this.http.post<LoginResult>(`${this.baseUrl}/login`, { Email: email, Password: password }, { headers: this.header });
    }

    forgotPassword(email: string) {
        return this.http.post<ForgotPasswordResponse>(`${this.baseUrl}/forgot-password`, { email }, { headers: this.header });
    }

    changePassword(email: string, oldPassword: string, newPassword: string, confirmNewPassword: string) {
        return this.http.post<ChangePasswordResponse>(`${this.baseUrl}/change-password`, { email, oldPassword, newPassword, confirmNewPassword }, { headers: this.header });
    }

    getRefreshToken(refreshToken: string) {
        return this.http.post<GetRefreshTokenResponse>(`${this.baseUrl}/refresh`, { refreshToken }, { headers: this.header });
    }
}
